import config from "../../utils/config";
import API from "../../utils/endpoints";
import * as types from "./actionType";
import axios from "axios";

export function toggleClassAside(payload) {
  return {
    type: types.TOGGLE_CLASS_ASIDE,
    payload,
  };
}

function submittingActivityLog() {
  return { type: types.CREATE_LOG };
}

function submittingActivityLogSuccess() {
  return { type: types.CREATE_LOG_SUCCESS };
}

function submittingActivityLogFailed() {
  return { type: types.CREATE_LOG_FAILED };
}

function fetchCountryFromFireBase() {
  return { type: types.FETCH_COUNTRY };
}

function fetchCountryFromFireBaseSuccess(payload) {
  return { type: types.FETCH_COUNTRY_SUCCESS, payload };
}

function fetchCountryFromFireBaseFailure() {
  return { type: types.FETCH_COUNTRY_FAILURE };
}

function fetchRegionJson() {
  return { type: types.FETCH_REGION_JSON };
}

function fetchRegionJsonSuccess(payload) {
  return { type: types.FETCH_REGION_JSON_SUCCESS, payload };
}

function fetchRegionJsonFailure() {
  return { type: types.FETCH_REGION_JSON_FAILURE };
}

function fetchCountriesJson() {
  return { type: types.FETCH_COUNTRIES_JSON };
}

function fetchCountriesJsonSuccess(payload) {
  return { type: types.FETCH_COUNTRIES_JSON_SUCCESS, payload };
}

function fetchCountriesJsonFailure() {
  return { type: types.FETCH_COUNTRIES_JSON_FAILURE };
}

function fetchTestimonialCountriesJson() {
  return { type: types.FETCH_TESTIMONIAL_COUNTRIES_JSON };
}

function fetchTestimonialCountriesJsonSuccess(payload) {
  return { type: types.FETCH_TESTIMONIAL_COUNTRIES_JSON_SUCCESS, payload };
}

function fetchTestimonialCountriesJsonFailure() {
  return { type: types.FETCH_TESTIMONIAL_COUNTRIES_JSON_FAILURE };
}

export const createLog = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(submittingActivityLog());

    let response = await api.post(API.createLog, payload);
    if (response.data.code === 200) {
      dispatch(submittingActivityLogSuccess());
    } else {
      dispatch(submittingActivityLogFailed());
    }
  } catch (error) {
    dispatch(submittingActivityLogFailed());
  }
};

export function updateConfig(payload) {
  return {
    type: types.UPDATE_FIREBASE_CONFIG,
    payload,
  };
}

export const updateGlobalConfig = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchCountryFromFireBase());
  let data = payload.default.config;
  axios
    .get(data.countries)
    .then((response) => {
      if (response.status === 200) {
        dispatch(fetchCountryFromFireBaseSuccess(response.data));
        localStorage.setItem("countries", JSON.stringify(response.data));
      } else {
        dispatch(fetchCountryFromFireBaseFailure());
      }
    })
    .catch((error) => {});
};

// export const crashApi = (payload) => async(dispatch, getState, api) => {
export const crashApi = (payload) => {
  return {
    type: types.CRASH_API,
    payload,
  };
};

export const runCrashedApi = async (payload) => {
  // var arr = await axios(payload);

  return {
    type: types.CRASH_API_REVIVE,
  };
};

export const fetchingRegionJson = () => async (dispatch, getState, api) => {
  dispatch(fetchRegionJson());

  axios
    .get(`${config.countryJsonUrl}/node/assets/EUtours/region.json`)
    .then((response) => {
      if (response.status === 200) {
        dispatch(fetchRegionJsonSuccess(response.data));
      } else {
        dispatch(fetchRegionJsonFailure());
      }
    })
    .catch((error) => {});
};

export const fetchingCountriesJson = () => async (dispatch, getState, api) => {
  dispatch(fetchCountriesJson());

  axios
    .get(
      `${config.countryJsonUrl}/node/assets/dashboard/riders-portal/wanderlustCountries.json`
    )
    .then((response) => {
      if (response.status === 200) {
        dispatch(fetchCountriesJsonSuccess(response.data));
      } else {
        dispatch(fetchCountriesJsonFailure());
      }
    })
    .catch((error) => {});
};

export const fetchingTestimonialCountriesJson = () => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchTestimonialCountriesJson());

  axios
    .get(`${config.countryJsonUrl}/bin/fetchcountrystate`)
    .then((response) => {
      if (response.status === 200) {
        dispatch(fetchTestimonialCountriesJsonSuccess(response.data));
      } else {
        dispatch(fetchTestimonialCountriesJsonFailure());
      }
    })
    .catch((error) => {});
};
